import ElementDocument from "../types/ElementDocument";

export function assetUploadedBy(currentDocuments: ElementDocument[], t: any):string {
    if (currentDocuments.length > 1) {
        let multipleUploaders = false;

        currentDocuments.forEach((doc: ElementDocument, index: number) => {
            if (index === 0) {
                return;
            }

            multipleUploaders = doc.metadata["asset-uploaded-by"] !== currentDocuments[index - 1].metadata["asset-uploaded-by"];
        });

        return multipleUploaders ? t("inspection.documents.multiple") : currentDocuments[0]?.metadata["asset-uploaded-by"];
    }

    return currentDocuments[0]?.metadata["asset-uploaded-by"] ?? null;
}